<template>
  <ul class="dots-loader" :class="{ 'dots-loader__border': hasBorders }">
    <li class="dots-loader__dot" :class="[dotsBgColorClass]"></li>
    <li class="dots-loader__dot" :class="[dotsBgColorClass]"></li>
    <li class="dots-loader__dot" :class="[dotsBgColorClass]"></li>
  </ul>
</template>

<script>
export default {
  name: 'LoadingDots',
  props: {
    dotsBgColorClass: {
      type: String,
      default: 'bg-white'
    },
    hasBorders: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.dots-loader {
  $parent: &;
  display: flex;

  &__dot {
    width: var(--grid-8);
    height: var(--grid-8);
    border-radius: 100%;

    &:not(:last-of-type) {
      margin-right: 10px;
    }

    &:first-of-type {
      animation: dotsKeyframes 1.2s infinite;
    }

    &:nth-of-type(2) {
      animation: dotsKeyframes 1.2s 0.4s infinite;
    }

    &:nth-of-type(3) {
      animation: dotsKeyframes 1.2s 0.8s infinite;
    }
  }

  &__border {
    #{$parent}__dot {
      border: 1px solid var(--color-brand-purple);
    }
  }
}

@keyframes dotsKeyframes {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.6);
  }
  100% {
    transform: scale(1);
  }
}
</style>
